module.exports = __webpack_public_path__ + "static/img/banner_product4.8168ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comm/banner_product4.jpg
// module id = idFZ
// module chunks = 0